import { Entity } from '@/store/entity'

export class Partner extends Entity {

}
